export function formatItemYear(year, yearEnd = null) {
  const start = Number(year);
  const end = Number(yearEnd);

  if (!Number.isFinite(start) || start <= 0) return "";
  if (!Number.isFinite(end) || end <= 0 || end === start) return String(start);

  // Consecutive sports seasons conventionally read 1989-90.
  if (end === start + 1 && Math.floor(start / 100) === Math.floor(end / 100)) {
    return `${start}-${String(end).slice(-2)}`;
  }

  return `${start}-${end}`;
}
